import React from "react";
import { DashboardComponent } from "@aidkitorg/types/lib/survey";
import { TranslatedComponentResult } from "@aidkitorg/types/lib/admin-panel/dashboard";

type MetricProps = {
  component: DashboardComponent,
  result?: TranslatedComponentResult
}

export const Metric = ({ component, result }: MetricProps) => {

  // This shouldn't happen but in case we render this for a component that isn't a Hero Number kind
  // This is more of a type-assurance for TypeScript
  if (component.kind !== 'Hero Number') {
    // Throw an error here
    return (<></>)
  }

  const metricValue = () => {
    if (component.summary.kind === 'Percentage') {
      return result?.data[0][result?.summaryKey] || '--'
    } else {
      switch(component.summary.kind) {
        case 'Count':
          return result?.data[0]['count_applicants'] || '--'
        case 'Sum':
        case 'Mean':        
          return result?.data[0][result?.summaryKey] || '--'
      }
    }
  }
  
  const prefix = component.prefix || ''
  const suffix = component.suffix || ''
  const value = metricValue()

  const formattedValue = !isNaN(value) ? 
    component.useCommas
      ? new Intl.NumberFormat('en-US', {
        maximumFractionDigits: component.decimalPlaces,
        minimumFractionDigits: component.decimalPlaces,
      }).format(parseFloat(value))
      : parseFloat(value).toFixed(component.decimalPlaces) 
    : '--'

  return (
    // TODO: update styling so that it matches bolt better, leave for now
    <div className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold text-center">
      {prefix}{formattedValue}{suffix}
    </div>
  )
}